import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * EB Layout Route Definition
 * Renders Outlet to display child routes (index for /eb, broker for /eb/broker/$msid)
 *
 * Authentication is handled by the parent _protected layout route.
 */
export const Route = createFileRoute('/_protected/eb')({
  component: () => <Outlet />,
});
